// extracted by mini-css-extract-plugin
export default {"cookieButton":"CookieSettings_cookieButton__3K3b0","jump":"CookieSettings_jump__xtONO"};